import React from 'react'
import { Percent, Plus, Calculator } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export const Taxes: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Tax Configuration</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">Manage tax rates and tax calculation rules</p>
        </div>
        <Button><Plus className="w-4 h-4 mr-2" />Add Tax Rate</Button>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Percent className="w-5 h-5" />Tax Management
          </CardTitle>
          <CardDescription>Tax rates, rules, and calculation settings</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <Calculator className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Tax Configuration</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Configure tax rates and calculation rules</p>
            <Button variant="outline">Setup Taxes</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
